module.exports = __webpack_public_path__ + "img/benefits02-01.6132e31.png";